import React from 'react';

import Product from './Product';

function Gallery({ products, cart, updateCart, shopClosedUntilDate }) {
	return (
		<div className="shop__collection">
			<div className="collection__products">
				{products.map(product => <Product shopClosedUntilDate={shopClosedUntilDate} key={product.id} item={product} cart={cart} updateCart={updateCart} />)}
			</div>
		</div>
	);
}

Gallery.defaultProps = {
	products: [],
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/Gallery.js